"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePermissions = exports.PermissionsProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useGetPolicies2 = require("@/api/useGetPolicies");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PermissionsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var PermissionsProvider = exports.PermissionsProvider = function PermissionsProvider(_ref) {
  var children = _ref.children;
  var _useGetPolicies = (0, _useGetPolicies2.useGetPolicies)(),
    policiesResponse = _useGetPolicies.data;
  var _useState = (0, _react.useState)(new Set()),
    _useState2 = _slicedToArray(_useState, 2),
    userPermissions = _useState2[0],
    setUserPermissions = _useState2[1];
  var loadPermissions = function loadPermissions(permissionsFromDB) {
    setUserPermissions(new Set(permissionsFromDB));
  };
  var hasPermission = function hasPermission(permission) {
    return userPermissions.has(permission);
  };
  var hasAnyPermission = function hasAnyPermission(permissions) {
    return permissions.some(function (permission) {
      return userPermissions.has(permission);
    });
  };
  var hasAllPermissions = function hasAllPermissions(permissions) {
    return permissions.every(function (permission) {
      return userPermissions.has(permission);
    });
  };
  (0, _react.useEffect)(function () {
    if ((policiesResponse === null || policiesResponse === void 0 ? void 0 : policiesResponse.status) === 200) {
      var policies = policiesResponse.policies;
      var policiesMapped = policies.flatMap(function (p) {
        return p.resource_action;
      }).flatMap(function (ra) {
        return ra.action;
      });
      loadPermissions(Array.from(new Set(policiesMapped)));
    }
  }, [policiesResponse]);
  var contextValue = _react["default"].useMemo(function () {
    return {
      hasPermission: hasPermission,
      hasAnyPermission: hasAnyPermission,
      hasAllPermissions: hasAllPermissions,
      setPermissions: loadPermissions
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [userPermissions]);
  return /*#__PURE__*/_react["default"].createElement(PermissionsContext.Provider, {
    value: contextValue
  }, children);
};
var usePermissions = exports.usePermissions = function usePermissions() {
  var context = (0, _react.useContext)(PermissionsContext);
  if (!context) {
    throw new Error("usePermissions must be used inside PermissionsProvider");
  }
  return context;
};